export const reviewsFilter = {
  Newest: 0,
  Oldest: 1,
  StarsAscending: 2,
  StarsDescending: 3,
};

export const reviewsFilterSelect = Object.entries(reviewsFilter).map(([label, value]) => ({ label, value }));
